export default __webpack_public_path__ + "static/media/delete-white.7442009a.svg";